import React from 'react'
import './styles.scss'

import { ReactComponent as HeroOrb } from '../../../images/pricing/new/hero-orb.svg'
import { ReactComponent as ShooterShort } from '../../../images/pricing/new/shooter-short.svg'
import { ReactComponent as ShooterMedium } from '../../../images/pricing/new/shooter-medium.svg'
import { ReactComponent as ShootingSwitch } from '../../../images/pricing/new/shooting-switch.svg'
import { ReactComponent as ShooterDarkMedium } from '../../../images/pricing/new/shooter-dark-medium.svg'
import { ReactComponent as ShooterLong } from '../../../images/pricing/new/shooter-long.svg'

const PricingHero = () => {
  return (
    <div className="pricing-header-stars">
      <HeroOrb className="pricing-hero-orb" />
      <ShooterShort className="pricing-shooter-short" />
      <ShooterMedium className="pricing-shooter-medium" />
      <ShootingSwitch className="pricing-shooting-switch" />
      <ShooterDarkMedium className="pricing-shooter-dark-medium" />
      <ShooterLong className="pricing-shooter-long" />
    </div>
  )
}

export default PricingHero
